import React, { useState, useEffect, useRef, useContext } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
// MUI Modal
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { AuthContext } from '../../context/AuthContext';
import SecurityHeaders from '../../data/SecurityHeaders';
import MalwareAssignmentItem from './MalwareAssignmentItem';
import MalwareAssignmentItemSkeleton from './MalwareAssignmentItemSkeleton';


const MalwareAssignments = () => {
    const { user } = useContext(AuthContext);
    const { challenge_id } = useParams();
    const [challenges, setChallenges] = useState(null);
    const [timeLeft, setTimeLeft] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Snackbar state
   
 useEffect(() => {
  const tryParseJSON = (value, fallback) => {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error(`Failed to parse JSON: ${value}`, e);
      return fallback;
    }
  };

  const fetchChallenge = async () => {
    try {
      const response = await axios.get('https://skillsuprise.com/malware-assignments.php', SecurityHeaders );
      if (response.data.status === 'error') {
        setError('Failed to fetch challenge details');
      } else {
        const parsed = response.data.data.map((challenge) => ({
          ...challenge,
          skills_required: Array.isArray(challenge.skills_required)
            ? challenge.skills_required
            : tryParseJSON(challenge.skills_required, []),
          instructions: Array.isArray(challenge.instructions)
            ? challenge.instructions
            : tryParseJSON(challenge.instructions, []),
          submission_process: Array.isArray(challenge.submission_process)
            ? challenge.submission_process
            : tryParseJSON(challenge.submission_process, []),
          prize_money: parseFloat(challenge.prize_money) || 0, // Parse prize_money to number
        }));
        setChallenges(parsed);
      }
    } catch (err) {
      setError('Error fetching challenge');
    } finally {
      setLoading(false);
    }
  };

  fetchChallenge();
}, [SecurityHeaders]);

   console.log(challenges);

    if (loading) {
        return <MainContainer>{Array(5).map(()=><MalwareAssignmentItemSkeleton/>)}</MainContainer>;
    }

    

    return (
        <MainContainer  className=" ">
          <div className='container my-4'>


          
{
    Array.isArray(challenges) && challenges.length > 0 ? challenges.map((challenge) => (
        <MalwareAssignmentItem key={challenge.challenge_id} challenge={challenge} />
    )) : <div className='d-flex col-12 align-items-center vh-100' >No challenges available.</div>
}
              
  </div>

          
        </MainContainer>
    );
};

export default MalwareAssignments;

const MainContainer = styled.div`
    // min-height: 85vh;
    font-family: sans-serif;
    
  
    background-color: #f8f9fa;
`;

